export default {
    data: function() {
        return {
            months: [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre',
            ],
        }
    },
    computed: {
        getCurrentDate: function() {
            let date = new Date()
            return `${date.getDate()}/${this.months[date.getMonth()]}/${date.getFullYear()}`
        },
    },

    methods: {
        formatDate(date){
            return `${date.getDate()}/${this.months[date.getMonth()]}/${date.getFullYear()}`
        }
    },
    
}